var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSpace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2H4C2.89778 2 2 2.89778 2 4V9.33333H12V2Z",
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 2H13.3333V9.33333H17.9999V4C17.9999 2.89778 17.1021 2 15.9999 2Z",
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2 17.1022 2.89778 18 4 18H6.66667V10.6667H2V16Z",
    fill: "#FF8C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18H16C17.1022 18 18 17.1022 18 16V10.6667H8V18Z",
    fill: "#FF8C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSpace);
export default __webpack_public_path__ + "static/media/ico-space.bd70dd50efb0e3fa65b449569dbe75d7.svg";
export { ForwardRef as ReactComponent };